<template><div><h1>VUX V2.0.0 released</h1>
<h2><a href="/en/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[change] upgrade to vue@2.0, use `v-model` instead of `:show.sync`</li>
<li>[feature] add prop close-on-clicking-mask</li>
</ul>
<h2><a href="/en/components/alert.html">Alert</a></h2>
<ul><li>[change] use `v-model` instead of `:show.sync`</li>
<li>[todo] fix animation</li>
</ul>
<h2><a href="/en/components/button-tab.html">ButtonTab</a></h2>
<ul><li>[enhance] remove tap highlight</li>
</ul>
<h2><a href="/en/components/checker.html">Checker</a></h2>
<ul><li>[feature] Support Object value #705</li>
</ul>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[change] it does not show errors by default, handle errors by on-error events</li>
<li>[feature] add slot:footer slot:after-title</li>
<li>[change] if value.length === max, the left items will be disabled</li>
<li>[change] default required value is false</li>
</ul>
<h2><a href="/en/components/color-picker.html">ColorPicker</a></h2>
<ul></ul>
<h2><a href="/en/components/countdown.html">Countdown</a></h2>
<ul><li>[deprecated] This component is no longer maintained</li>
</ul>
<h2><a href="/en/components/countup.html">Countup</a></h2>
<ul><li>[feature] Add prop:start</li>
<li>[change] Update countup -> countup.js</li>
</ul>
<h2><a href="/en/components/form-preview.html">FormPreview</a></h2>
<ul></ul>
<h2><a href="/en/components/load-more.html">LoadMore</a></h2>
<ul><li>[feature] Add `load-more` component</li>
</ul>
<h2><a href="/en/components/popover.html">Popover</a></h2>
<ul><li>[todo] wrong position if changing locale</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[change] use `v-model` instead of `:show.sync`</li>
<li>[change] do not show mask by default</li>
<li>[feature] add prop:isShowMask</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul></ul>
<h2><a href="/en/components/x-number.html">XNumber</a></h2>
<ul><li>[change] set `fiilable` default value to `false`</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.0.0 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.0.0-72.vue?1d47e54c